import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=62b06653&scoped=true&"
import script from "./FormTextArea.vue?vue&type=script&lang=js&"
export * from "./FormTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b06653",
  null
  
)

export default component.exports